module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_10_m.fa17045b6bf5f1cb07bc92db3beed960.png";